import { takeLatest, put } from "redux-saga/effects";
import {
  FETCH_DossierComplet_REQUEST,
  REDIRECT_TO_LOGIN,
} from "./actionsTypes";
import {
  fetchDossierCompletSuccess,
  FETCH_SasData_FAILURE,
  redirectToLogin,
} from "./actions";
import axios from "axios";
import Config from "config";
function* fetchDossierComplet(action) {
  // const { token} = action.payload;
  const api = Config.backOffice.apiName;
  const token = localStorage.getItem("auth_token_" + api);
  try {
    const response = yield axios.get(
      `https://www.fluxod.com/${api}/fdashboards/widget_dossiers_complets`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    yield put(fetchDossierCompletSuccess(response.data));
  } catch (error) {
    yield put({ type: REDIRECT_TO_LOGIN });
  }
}

function* dossierCompletSaga() {
  yield takeLatest(FETCH_DossierComplet_REQUEST, fetchDossierComplet);
}

export default dossierCompletSaga;
